import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { UserService } from "src/app/services/user.service";

@Component({
    selector: 'add-account-dialog',
    template: `
      <div class="joi-dialog">
        <div mat-dialog-title>
            <span>New Account</span>
        </div>
        <div mat-dialog-content style="margin-top:20px;">
          <form #accountForm="ngForm">
            <mat-form-field class="general">
              <input matInput name="title" (keydown.enter)="dialogRef.close(title)" [(ngModel)]="title" placeholder="Account title" required>
            </mat-form-field>
          </form>
        </div>
        <div mat-dialog-actions id="action">
          <button mat-button (click)="dialogRef.close()">CANCEL</button>
          <button mat-button color="primary" [disabled]="!title" (click)="dialogRef.close(title)">CREATE</button>
        </div>
      </div>
    `,
    standalone: true,
    imports: [ FormsModule, MatButtonModule, MatFormFieldModule, MatInputModule],
})
export class AddAccountDialogComponent {
  title = '';
  constructor(public dialogRef: MatDialogRef<AddAccountDialogComponent>, public user: UserService) {
  }
}
